import React, { MouseEvent, useEffect, useState } from 'react';

import './Tabs.scss';

interface TabsProps {
    labels: Array<string>;
    contents?: Array<React.ReactNode>;
    className?: string;
    onClick?: (event?: MouseEvent<HTMLLIElement>) => void;
    selectedIndex?: number;
}

export default function Tabs({ labels, contents, className, onClick, selectedIndex }: TabsProps) {
    // TODO: WTF storybook
    const [activeTabIndex, setActiveTabIndex] = useState(selectedIndex ?? 0);

    useEffect(() => {
        if (typeof selectedIndex === 'number') {
            setActiveTabIndex(selectedIndex);
        }
    }, [selectedIndex]);

    const onTabClick = (i: number, event?: MouseEvent<HTMLLIElement>) => {
        setActiveTabIndex(i);
        if (onClick) onClick(event);
    };

    const getTabClasses = (idx: number) => {
        return `tabs__nav-item ${idx === activeTabIndex ? 'tabs__nav-item--active' : ''}`;
    };

    const getTabContentClasses = (idx: number) => {
        return `tabs__content-item ${idx === activeTabIndex ? 'tabs__content-item--active' : ''}`;
    };

    return (
        <div className={`tabs ${className ? className : ''}`}>
            <div className="tabs__nav-container">
                <nav className="tabs__nav">
                    <ul className="tabs__nav-list">
                        {labels.map((label, i) => (
                            <li
                                className={getTabClasses(i)}
                                key={i}
                                onClick={(event: MouseEvent<HTMLLIElement>) => onTabClick(i, event)}
                                tabIndex={i}
                            >
                                {label}
                            </li>
                        ))}
                    </ul>
                </nav>
            </div>
            {contents && (
                <div className="tabs__content-container">
                    {contents.map((content, i) => (
                        <div className={getTabContentClasses(i)} key={i}>
                            {content}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
